import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';
import { useEffect } from 'react';
import { useTimeout } from 'ahooks';

export interface ReactionChangeChangeData {
  senderUid: string; //发送表情的参会人 ID
  senderDeviceId: string; //发送表情的参会设备 ID
  emoticonId: string; //表情 ID
  emoticonAnimationWebp: string; //表情的 Webp 动画资源地址
  emoticonAnimationWebpDuration: number; //表情的 Webp 动画时长
  isHandup?: number;
  memberUid?: string; //举手的参会人 ID
  senderYxMeetingUid: string;
}

export default function useReactionChange() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });

  const change = async (body: ReactionChangeChangeData) => {
    meeting?.updateRectionMap(body.senderYxMeetingUid, {
      senderUid: body.senderYxMeetingUid,
      emoticonId: body.emoticonId,
      emoticonAnimationWebp: body.emoticonAnimationWebp,
      emoticonAnimationWebpDuration: body.emoticonAnimationWebpDuration,
    });
  };

  return change;
}
